import { SCHEMA_PROPS } from '../constants';
export var inferFilterType = function inferFilterType(filter, schema) {
  var operator = filter.operator,
      propertyType = filter.propertyType;
  if (propertyType) return propertyType;
  if (operator === 'within') return 'Geo';
  return SCHEMA_PROPS[schema[filter.propertyName]];
};